__turbopack_context__.v({
  "copyButton": "WalletSign-module__SPKuaG__copyButton",
  "description": "WalletSign-module__SPKuaG__description",
  "form": "WalletSign-module__SPKuaG__form",
  "header": "WalletSign-module__SPKuaG__header",
  "input": "WalletSign-module__SPKuaG__input",
  "loading": "WalletSign-module__SPKuaG__loading",
  "root": "WalletSign-module__SPKuaG__root",
  "signature": "WalletSign-module__SPKuaG__signature",
  "signatureContainer": "WalletSign-module__SPKuaG__signatureContainer",
  "title": "WalletSign-module__SPKuaG__title",
});
